/**
 * @file index.tsx
 *
 * @fileoverview Renders a custom promoted organization icon.
 */

import { BadgeIcon } from '~/vcl/icons/Badge';

interface OrganizationPromotedIconSlotProps {
  /**
   * The width of the icon.
   */
  width?: string;
  /**
   * The height of the icon.
   */
  height?: string;
}

export default function OrganizationPromotedIconSlot({
  width,
  height,
}: OrganizationPromotedIconSlotProps) {
  return (
    <BadgeIcon
      {...(width ? { width } : {})}
      {...(height ? { height } : {})}
      color="featured"
    />
  );
}
export { OrganizationPromotedIconSlot };
